export default {
    state: {
        headerDontHaveShipping: [['Date', 'Dont have invoices']],
        countDontHaveShipping: [],

        headerNotPaidMoreMonth: [['Date', 'Not Paid orders']],
        countNotPaidMoreMonth: [],

        headerUnpaidInvoices: [['Date', 'Unpaid invoices']],
        countUnpaidInvoices: [],

        processState: true,
    },
    mutations: {
        setCountDontHaveShipping(state, payload) {
            state.countDontHaveShipping = [];
            state.countDontHaveShipping = [ ...state.headerDontHaveShipping, ...payload];
        },
        setCountNotPaidMoreMonth(state, payload) {
            state.countNotPaidMoreMonth = [];
            state.countNotPaidMoreMonth = [ ...state.headerNotPaidMoreMonth, ...payload];
        },
        setCountUnpaidInvoices(state, payload) {
            state.countUnpaidInvoices = [];
            state.countUnpaidInvoices = [ ...state.headerUnpaidInvoices, ...payload];
        },
        setProcessState(state, payload) {
            state.processState = !!payload;
        },
    },
    actions: {
        setCountDontHaveShipping({commit}, payload) {
            commit('setCountDontHaveShipping', payload);
        },
        setNotPaidMoreMonth({commit}, payload) {
            commit('setCountNotPaidMoreMonth', payload);
        },
        setUnpaidInvoices({commit}, payload) {
            commit('setCountUnpaidInvoices', payload);
        },
        setProcessState({commit}, payload) {
            commit('setProcessState', !!payload);
        },
    },
    getters: {
        getCountDontHaveShipping(state) {
            return state.countDontHaveShipping;
        },
        getCountNotPaidMoreMonth(state) {
            return state.countNotPaidMoreMonth;
        },
        getCountUnpaidInvoices(state) {
            return state.countUnpaidInvoices;
        },
        getProcessState(state) {
            return state.processState;
        },
    }
}
